import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { TranslationRequestDto } from '@app/data/dtos/content-translator/content-translador.dto';

export interface ContentTranslateRepository {
  translate(translationRequest: TranslationRequestDto): Observable<string>;
}

export const CONTENT_TRANSLATE_REPOSITORY = new InjectionToken<ContentTranslateRepository>(
  'CONTENT_TRANSLATE_REPOSITORY'
);
